import activityFactory from '@polleverywhere/core/lib/activity_factory'

/**
 * Get the correct activity model
 *
 * Allows for using GraphQL where appropriate
 *
 * @param {Object} data
 * @param {string} data.type Activity type
 * @param {string} [data.participant_key] The participant key
 * @param {string} [data.presenter_key] The presenter key
 * @param {string} [data.shared_key] The shared key
 * @param {string} [data.permalink] DEPRECATED use shared_key
 * @param {Object} [options]
 * @param {boolean} [options.legacy=false] Set true to use legacy models only, otherwise GraphQL will be used where available
 * @return {Promise<Backbone.Model=>} May resolve undefined if data doesn't resolve to a Model
 */
export default async function (data, options = {}) {
  if (!options.legacy) {
    if (data.type === 'discourse') {
      const GQLDiscourse = (await import(/* webpackChunkName: 'graphql-models-qa' */ './participant/discourse')).default
      return new GQLDiscourse({
        participant_key: data.participant_key
      })
    }
  }
  return Promise.resolve(activityFactory(data, options))
}
